import { createSlice } from "@reduxjs/toolkit";

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    categoriesArray:[]
  },
  reducers: {
    getAllCategories: (state, action) => {
  state.categoriesArray =action.payload;
 },
 },
});

export const { getAllCategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;
